module.exports = __webpack_public_path__ + "static/osticket-214c16a85047ad91f1dfcddfb916db68.png";